var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowLeftBlue = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 16,
  viewBox: "0 0 20 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0.292893 7.29289C-0.0976314 7.68341 -0.0976315 8.31658 0.292892 8.7071L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34314C8.46159 1.95262 8.46159 1.31945 8.07107 0.92893C7.68055 0.538406 7.04738 0.538406 6.65686 0.92893L0.292893 7.29289ZM20 7L1 7L1 9L20 9L20 7Z",
  fill: "#0A3887"
})));
export { SvgArrowLeftBlue as ReactComponent };
export default __webpack_public_path__ + "ba5e192e0c97174e9de7e900c838baf7.svg";